import React, { FC, SyntheticEvent, ChangeEvent, RefAttributes, forwardRef } from 'react';
import { Error } from '../Error';
import { time } from 'uniqid';
import { isEmpty } from 'lodash';

export interface TextAreaProps {
  id?: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: SyntheticEvent) => void;
  onFocus?: (e: SyntheticEvent) => void;
  onPaste?: (e: SyntheticEvent) => void;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  rows?: number;
  error?: string;
  showError?: boolean;
  showLabel?: boolean;
  maxLength?: number;
  minLength?: number;
  showCount?: boolean;
  children?: React.ReactNode;
}

export const TextArea: FC<TextAreaProps & RefAttributes<HTMLTextAreaElement>> = forwardRef<
  HTMLTextAreaElement,
  TextAreaProps
>(
  (
    {
      children,
      id = time('input-id-'),
      disabled = false,
      onChange,
      onBlur = () => true,
      onFocus = () => true,
      onPaste = () => true,
      name,
      className = '',
      value,
      placeholder,
      rows,
      error,
      showError = true,
      showLabel = true,
      showCount = false,
      maxLength,
      minLength
    },
    ref
  ) => (
    <div className={`d-flex flex-column ${className}`}>
      <label htmlFor={id} className={!showLabel ? 'sr-only' : ''}>
        {children}
      </label>
      <textarea
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onPaste={onPaste}
        onFocus={onFocus}
        disabled={disabled}
        ref={ref}
        value={value}
        placeholder={placeholder}
        rows={rows}
        className={`text-area ${!isEmpty(error) && !disabled ? 'error' : ''}`}
        data-testid={id}
        maxLength={maxLength}
        minLength={minLength}
      />
      {showCount && (
        <small className="text-right m-0">
          {value.length}/{maxLength}
        </small>
      )}
      <Error errors={error} showError={showError} />
    </div>
  )
);

TextArea.displayName = 'TextArea';
export default TextArea;
